import React from 'react';
import PropTypes from 'prop-types';

import { Anchor, Text, TextButton } from '@zillow/constellation-10';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import CaretUpIcon from '@zg-rentals/multibrand-ui/lib/icons/CaretUp';
import CaretDownIcon from '@zg-rentals/multibrand-ui/lib/icons/CaretDown';
import StringConstants from '@common/constants/StringConstants';

interface IContactUsSectionProps {
  expandable?: boolean;
  startsOpen?: boolean;
  isLandlord?: boolean;
}

class ContactUsSection extends React.Component<IContactUsSectionProps> {
  static defaultProps = {
    expandable: true,
    startsOpen: false,
  };

  static propTypes = {
    expandable: PropTypes.bool,
    startsOpen: PropTypes.bool,
  };

  state = {
    isOpen: this.props.startsOpen || !this.props.expandable,
  };

  toggleOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  getFaqLink() {
    const { isLandlord } = this.props;

    if (isLandlord) {
      return StringConstants.LINKS.FAQ_PAGE.zrm;
    }
    return StringConstants.LINKS.FAQ_PAGE.zillow;
  }

  /**
   * Formats a phone number for displaying
   * Input: '4153760367'
   * Output: '(415) 376-0367'
   */
  getFormattedPhoneNumber(s) {
    const s2 = `${s}`.replace(/\D/g, '');
    const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return !m ? null : `(${m[1]}) ${m[2]}-${m[3]}`;
  }

  renderOpenedSection() {
    const faqLink = this.getFaqLink();

    return (
      <>
        <SpacerRow />
        <Anchor target="_blank" href={faqLink}>
          Common Questions
        </Anchor>
        <SpacerRow />
        <Anchor href={`mailto:${StringConstants.LINKS.SUPPORT_EMAIL.zillow}`}>Email Us</Anchor>
      </>
    );
  }

  renderExpandedSection = () => {
    const { isOpen } = this.state;
    const ArrowIcon = isOpen ? CaretUpIcon : CaretDownIcon;
    return (
      <>
        <TextButton textStyle="body-sm" onClick={this.toggleOpen}>
          Contact us
          <ArrowIcon className="pls" size="10" colorType="action" />
        </TextButton>
      </>
    );
  };

  render() {
    const { expandable } = this.props;
    const { isOpen } = this.state;

    return (
      <>
        <Text textStyle="body-sm">Still have questions?&nbsp;</Text>
        {expandable && this.renderExpandedSection()}
        {isOpen && this.renderOpenedSection()}
      </>
    );
  }
}

export default ContactUsSection;
